export * from '@console/dynamic-plugin-sdk/src/utils/k8s/ws-factory';
